import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import _ from 'lodash';
import {
  StyledBoxInside,
  StyledTitleWidget,
  StyledWrapperSearch,
  StyledWrapperEmployerDirectory,
  StyledButtonClear,
  StyledWrapperPaginator
} from './style';
import { Bell } from '../../../../assets/images/index';
import NotificationList from '../../core/NotificationList/NotificationList';
import {
  filterNotifications,
  newGetNotificationNoViewed
} from '../../../utils/apiHeader';
import SearchFilterNotification from '../../core/SearchFilter/SearchFilterNotification';
import PaginatorVertical from '../../core/PaginatorVertical';
import InfiniteScroller from '../../core/InfiniteScroller';

const MyNotifications = ({ notifications }) => {
  const [list, setList] = useState(null);
  const [modalActive, setModalActive] = useState(false);
  const [filter, setFilter] = useState({});
  const pageCounter = 1;

  const getNotifications = params => {
    if (notifications && notifications.length > 0) {
      if (filter && Object.keys(filter).length === 0) {
        newGetNotificationNoViewed(params).then(notificationList => {
          setList(notificationList);
        });
      }
    }
  };

  const onFilter = f => {
    setFilter(f);
    filterNotifications(f).then(data => {
      const resData = data;
      const newData = [
        ..._.filter(data.content, d => d.viewed === false),
        ..._.filter(data.content, d => d.viewed === true)
      ];
      const sortData = _.sortBy(newData, d => d.sendDate).reverse();
      resData.content = sortData;
      setList(resData);
    });
  };

  const deleteNotification = idNotification => {
    getNotifications({});
    const auxList = list;
    const removedItem = _.remove(
      auxList.content,
      item => item?.idNotification === idNotification
    );
    if (removedItem !== undefined) {
      auxList.size -= 1;
      auxList.total -= 1;
      setList(auxList);
    }
    onFilter(filter);
  };

  useEffect(() => {
    getNotifications({});
  }, [notifications]);

  const openModal = () => {
    setModalActive(true);
  };

  const closeModal = () => {
    setModalActive(false);
  };

  const clearFilter = () => {
    setList(notifications);
    setFilter({});
  };

  const nextScroll = params => {
    getNotifications(params);
  };

  let nextSize;
  if (list) {
    nextSize =
      list.size < list.total * (list.page + 1)
        ? list.size * (pageCounter + 1)
        : list.total;
  }

  return (
    <div className="pressResume_container">
      <StyledBoxInside>
        <div className="directory-header">
          <StyledTitleWidget
            title="Mis Notificaciones"
            type="myNotifications"
            icon={Bell}
            size="xs"
            small
          />
        </div>
        <StyledWrapperSearch>
          {Object.keys(filter).length > 0 && (
            <StyledButtonClear onClick={() => clearFilter()}>
              Borrar filtros
            </StyledButtonClear>
          )}
          <SearchFilterNotification
            onClick={f => onFilter(f)}
            modalActive={modalActive}
            closeModal={() => closeModal()}
            openModal={() => openModal()}
            setFilter={f => onFilter(f)}
            filter={filter}
          />
        </StyledWrapperSearch>
        <StyledWrapperEmployerDirectory>
          <InfiniteScroller
            page={list ? list.page : 0}
            loadMore={() =>
              nextScroll({
                size: nextSize,
                ...filter
              })
            }
          >
            {list && (
              <NotificationList
                notificationList={list.content}
                onDelete={idNotification => deleteNotification(idNotification)}
              />
            )}
          </InfiniteScroller>
        </StyledWrapperEmployerDirectory>
        <StyledWrapperPaginator>
          {list && (
            <PaginatorVertical
              visibleItems={list.size <= list.total ? list.size : list.total}
              totalItems={list.total}
            />
          )}
        </StyledWrapperPaginator>
      </StyledBoxInside>
    </div>
  );
};

const mapStateToProps = ({ notifications }) => ({
  notifications: notifications.notificationsList
});

export default connect(mapStateToProps)(MyNotifications);
